class LocalAPIManager {
  static async signupWithEmailAndPassword(
    email: string,
    password: string,
    name: string | undefined
  ): Promise<any> {
    var signupData: { [key: string]: any } = {
      email: email,
      password: password,
    };
    if (name != null) {
      signupData["name"] = name;
    }

    return new Promise(async (resolve, reject) => {
      const res = await fetch(`/api/signup`, {
        method: "POST",
        body: JSON.stringify(signupData),
      });
      if (!res.ok) {
        console.log("error");
        console.log(res);
        // This will activate the closest `error.js` Error Boundary
        // throw new Error('Failed to fetch data');
        reject(res.statusText);
        console.log(res.statusText);
      } else {
        console.log("success");
        resolve(await res.json());
      }
    });
  }

  static async signupCodeConfirmation(
    email: string,
    verificationCode: string
  ): Promise<void> {
    var signupData: { [key: string]: any } = {
      email: email,
      verificationCode: verificationCode,
    };

    return new Promise(async (resolve, reject) => {
      const res = await fetch(`/api/signup/confirm`, {
        method: "POST",
        body: JSON.stringify(signupData),
      });
      if (!res.ok) {
        // This will activate the closest `error.js` Error Boundary
        // throw new Error('Failed to fetch data');
        reject(res.statusText);
        // console.log(res.statusText);
      } else {
        resolve(await res.json());
      }
    });
  }

  static async signupResendConfirmation(email: string): Promise<void> {
    var resetData: { [key: string]: any } = {
      email: email,
    };

    return new Promise(async (resolve, reject) => {
      const res = await fetch(`/api/signup/resendconfirmation`, {
        method: "POST",
        body: JSON.stringify(resetData),
      });
      if (!res.ok) {
        // This will activate the closest `error.js` Error Boundary
        // throw new Error('Failed to fetch data');
        reject(res.statusText);
        // console.log(res.statusText);
      } else {
        resolve();
      }
    });
  }

  static async resetPassword(email: string): Promise<void> {
    var resetData: { [key: string]: any } = {
      email: email,
    };

    return new Promise(async (resolve, reject) => {
      const res = await fetch(`/api/signup/reset`, {
        method: "POST",
        body: JSON.stringify(resetData),
      });
      if (!res.ok) {
        // This will activate the closest `error.js` Error Boundary
        // throw new Error('Failed to fetch data');
        reject(res.statusText);
        // console.log(res.statusText);
      } else {
        resolve();
      }
    });
  }
  static async confirmPasswordReset(
    email: string,
    code: string,
    newPassword: string
  ): Promise<void> {
    var resetData: { [key: string]: any } = {
      email,
      code,
      newPassword,
    };

    return new Promise(async (resolve, reject) => {
      const res = await fetch(`/api/signup/confirmpasswordreset`, {
        method: "POST",
        body: JSON.stringify(resetData),
      });

      if (!res.ok) {
        reject(res.statusText);
      } else {
        resolve();
      }
    });
  }
}

export default LocalAPIManager;
